import styled from 'styled-components';

export default styled.div`
	--gap: var(--spacing-x-large);
	display: flex;
	position: relative;
	height: var(--sticky-footer);
	align-items: center;
	justify-content: center;
	hr {
		position: absolute;
		top: 0;
		left: var(--gap);
		right: var(--gap);
	}
	/* OVERRIDES DUE TO COLLAPSIBLE SIDEBAR */
	.motif-tooltip-trigger-wrap,
	.motif-button {
		min-width: 0;
	}
	/* OVERRIDES DUE TO COLLAPSIBLE SIDEBAR */
`;
